import FormDetailPromotionChallengePage from './FormDetailPromotionChallengePage'
import { withFormDetailPromotionChallengePage } from './withFormDetailPromotionDiscountPage'

const ConnectedFormDetailPromotionChallengePage =
  withFormDetailPromotionChallengePage(FormDetailPromotionChallengePage)

export { ConnectedFormDetailPromotionChallengePage as FormDetailPromotionChallengePage }
